import JsBarcode from 'jsbarcode'
import { useEffect, useState } from 'react'
import styled, { RuleSet } from 'styled-components'

import Skeleton from 'react-loading-skeleton'
import { Typography } from 'src/components/common/Typography'

export interface BarcodeTextProps {
  style?: RuleSet<object>
  fontStyle?: RuleSet<object>
  color?: string
  value: string
}

export interface BarcodeScreenProps {
  style?: RuleSet<object>
  value?: string
  barcode_height: number
}

const BarcodeText = ({ fontStyle, style, color, value }: BarcodeTextProps) => {
  const printStringInGroups = (barcode: string): string => {
    const cleanedBarcode = barcode.replace(/\s+/g, '')
    return cleanedBarcode.match(/.{1,4}/g)?.join(' ') ?? ''
  }

  return (
    <Typography
      $fontStyle={fontStyle}
      $style={style}
      $color={color}
      as={!!value ? Typography : Skeleton}
    >
      {printStringInGroups(value)}
    </Typography>
  )
}

const BarcodeImage = ({ value, barcode_height, style }: BarcodeScreenProps) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (value) {
      const canvas = document.createElement('canvas')
      JsBarcode(canvas, value, { displayValue: false, height: barcode_height })
      setImageUrl(canvas.toDataURL('image/png'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <BarcodeImg
      as={!!imageUrl ? 'img' : Skeleton}
      src={imageUrl}
      alt="barcode img"
      $barcode_height={barcode_height}
      $style={style}
    />
  )
}

export const Barcode = {
  Image: BarcodeImage,
  Text: BarcodeText,
}

const BarcodeImg = styled.img<{ $style?: RuleSet<object>; $barcode_height: number }>`
  display: flex;
  width: 100%;
  height: ${(props) => props?.$barcode_height}px;
  ${(props) => props.$style};
`
